/**
 * Hosts Page Logic
 *
 * Admin remote host management page
 */

import { initAuthenticatedPage, hasPermission } from '../app/init.js';
import { fillHostsTable } from '../admin/hosts.js';
import { declareLoading, notificationDialog } from '../ui/dialogs.js';

/**
 * Initialize the hosts page
 */
export async function initHostsPage(): Promise<void> {
  const user = await initAuthenticatedPage();
  if (!user) return; // Will redirect to login

  // Check admin permission
  if (!hasPermission('admin')) {
    notificationDialog('Access denied: Admin permission required');
    window.location.href = '/';
    return;
  }

  // Load hosts table
  declareLoading();
  try {
    await fillHostsTable();
    // Show content after table is ready
    const content = document.getElementById('content');
    if (content) content.style.display = 'block';
  } catch (error) {
    const msg = error instanceof Error ? error.message : 'Failed to load hosts';
    notificationDialog(msg);
  }
}

// Export to window for onclick handlers
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).initHostsPage = initHostsPage;
}
